import { render } from "./SwdInfoBtn.vue?vue&type=template&id=a03888f8&scoped=true"
import script from "./SwdInfoBtn.vue?vue&type=script&lang=js"
export * from "./SwdInfoBtn.vue?vue&type=script&lang=js"

import "./SwdInfoBtn.vue?vue&type=style&index=0&id=a03888f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a03888f8"]])

export default __exports__